import "../style/mobile/M_Nav.css";


import time_icon_active from "../../assets/dashboard/nav-icon/Group 101.png";
import book_icon_active from "../../assets/dashboard/nav-icon/Group 102.png";
import list_icon_active from "../../assets/dashboard/nav-icon/Group 104.png";
import store_icon_active from "../../assets/dashboard/nav-icon/Group 105.png";


import { GrClose } from "react-icons/gr";

// import { Category,Message,Setting,Calendar,Wallet,Star,Activity } from 'react-iconly';
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";


// console.log(document.documentElement.clientHeight);
// document.querySelector(".nav").style.height=document.height;

let loc = window.location.pathname;

let loc_list2 = [
  true,
  false,
  false,
  false,
  false,
  false,
];
let old_nav_item_id = 1;
let old_nav_item_sub_id = 1;

if (loc === "/login"){
  loc_list2 = [
    false,
    false,
    false,
    false,
    false,
    true
  ]
}
old_nav_item_id = 6


let home_nva = [
  {
    id: 1,
    title: "",
    subset: [
      {
        id: 1,
        sub_id: 1,
        name: "صفحه اصلی",
        // icon:<Category className="nav-item-icon"/>
        // icon:dash_icon,
        // icon_active:dash_icon_active,
        icon: "",
        icon_active: "",
        // navItemIsActive: true,
        navItemIsActive: loc_list2[0],
        path: "/",
      },
      {
        id: 2,
        sub_id: 1,
        name: "امکانات",
        // icon:<Calendar className="nav-item-icon"/>
        icon: "",
        icon_active: time_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list2[1],
        path: "/",
      },
      {
        id: 3,
        sub_id: 1,
        name: "فروشگاه",
        icon: "",
        icon_active: book_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list2[2],
        path: "/",
      },
      // {
      //   id:4,
      //   sub_id:1,
      //   name:"کارنامه",
      //   // icon:<Activity className="nav-item-icon"/>
      //   icon:report_card_icon,
      //   icon_active:report_card_icon_active,
      //   // navItemIsActive:false,
      //   navItemIsActive: loc_list[3],
      //   path:"/",
      // },
      {
        id: 4,
        sub_id: 1,
        name: "درباره ما",
        icon: "",
        icon_active: list_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list2[3],
        path: "/",
      },
      {
        id: 5,
        sub_id: 1,
        name: "تماس با ما",
        icon: "",
        icon_active: store_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list2[4],
        path: "/",
      },
      {
        id: 6,
        sub_id: 1,
        name: "ورود به حساب کاربری",
        icon: "",
        icon_active: store_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list2[5],
        path: "/login",
      },
    ],
  },
];

// let inital_nav_list = home_nva;


const MHNav = () => {
  // console.log(document.getElementById("NAV"));

  const state = useSelector((state) => state.default);


  if (state.MNav === "open") {
    document.querySelector(".m-nav").classList.add("m-nav-open");
    document
      .querySelector(".m-nav-under-cover")
      .classList.add("m-nav-under-cover-open");
  }
  if (state.MNav === "close" && document.querySelector(".m-nav") !== null) {
    document.querySelector(".m-nav").classList.remove("m-nav-open");
    document
      .querySelector(".m-nav-under-cover")
      .classList.remove("m-nav-under-cover-open");
  }
  const [nav_list, set_nav_list] = useState(home_nva);
  console.log(nav_list);
  const [onii, set_onii] = useState(old_nav_item_id);
  const [onisi, set_onisi] = useState(old_nav_item_sub_id);

  const dispatch = useDispatch();
  const { close_Mnav } = bindActionCreators(actionCreators, dispatch);

  // const nav_open=()=>{
  //   if(!navPinisActive){
  //     // console.log(document.querySelector(".nav"));
  //     document.querySelector(".nav").classList.add("nav_hover");
  //     let nin = document.querySelectorAll(".nav-item-name");
  //     for(let i=0;i<nin.length;i++){
  //       nin[i].classList.add("nav-item-name-hover");
  //     }
  //     let nst = document.querySelectorAll(".nav-section-title");
  //     for(let i=0;i<nst.length;i++){
  //       nst[i].classList.add("nav-section-title-hover");
  //     }
  //     // open_nav();
  //     }
  //     document.querySelector(".nav-pin").classList.add("nav-pin-hover");
  // }

  // const nav_close=()=>{
  //   if(!navPinisActive){
  //     document.querySelector(".nav").classList.remove("nav_hover");
  //     let nin = document.querySelectorAll(".nav-item-name");
  //     for(let i=0;i<nin.length;i++){
  //       nin[i].classList.remove("nav-item-name-hover");
  //     }
  //     let nst = document.querySelectorAll(".nav-section-title");
  //     for(let i=0;i<nst.length;i++){
  //       nst[i].classList.remove("nav-section-title-hover");
  //     }
  //     // close_nav();
  //     }
  //     document.querySelector(".nav-pin").classList.remove("nav-pin-hover");
  // }

  // let navPinisActive = false;
  // const nav_is_pin=(e)=>{
  //   if(!navPinisActive){
  //     e.target.style.color="#111";
  //     open_nav();
  //   }
  //   else if(navPinisActive){
  //     e.target.style.color="#B5B5B5";
  //     close_nav();
  //   }
  //   navPinisActive = !navPinisActive;
  // }

  // let old_nav_item_id = 1;
  // let old_nav_item_sub_id = 1;

  const nav_item_choose = (id, sub_id) => {
    // console.log(old_nav_item_id, old_nav_item_sub_id);
    let new_nav_list = nav_list.map((item) => {
      item.subset.map((item) => {
        if (item.id === onii && item.sub_id === onisi) {
          item.navItemIsActive = false;
        }
        if (item.id === id && item.sub_id === sub_id) {
          item.navItemIsActive = true;
        }
        return { ...item };
      });
      return { ...item };
    });
    set_nav_list(new_nav_list);
    set_onii(id);
    set_onisi(sub_id);
  };
  return (
    <>
      <div className="m-nav-under-cover">
        <div className="m-nav-under-cover-close-btn">
          <GrClose
            className="m-nav-under-cover-close-btn-icon"
            onClick={() => close_Mnav()}
          />
        </div>
      </div>
      <div className="m-nav" id="M-NAV">
        {/* <div className="nav-pin">
        <RiPushpin2Line className="nav-pin-icon"  onClick={nav_is_pin}/>
      </div> */}
        {nav_list.map((item, i) => (
          <div
            key={item.id + "_" + Math.floor(Math.random() * 100) + i}
            className="m-nav-section"
          >
            <div className="m-nav-section-title">{item.title}</div>
            {item.subset.map((item, j) => (
              <Link
                to={item.path}
                style={
                  item.navItemIsActive
                    ? { backgroundColor: "rgba(46,129,232,0.06)" }
                    : null
                }
                key={item.id + "ss_" + Math.floor(Math.random() * 10) + j}
                className="m-nav-item"
                onClick={() => nav_item_choose(item.id, item.sub_id)}
              >
                {item.navItemIsActive && (
                  <div className="m-nav-item-line-bar"></div>
                )}
                {/* <img src={item.icon} alt="nav-icon" className="nav-item-icon" /> */}
                <div className="m-nav-item-icon-container">
                  {/* {item.icon} */}
                  {item.navItemIsActive && item.icon && (
                    <img
                      src={item.icon_active}
                      alt="nav-icon"
                      className="m-nav-item-icon"
                    />
                  )}
                  {!item.navItemIsActive && item.icon && (
                    <img
                      src={item.icon}
                      alt="nav-icon"
                      className="m-nav-item-icon"
                    />
                  )}
                  {!item.icon && (
                    <div
                      style={
                        item.navItemIsActive ? { borderColor: "#2E81E8" } : null
                      }
                      className="home-nav-icon"
                    ></div>
                  )}
                </div>
                <div
                  style={item.navItemIsActive ? { color: "#2E81E8" } : null}
                  className="m-nav-item-name"
                >
                  {item.name}
                </div>
              </Link>
            ))}
            <div className="m-nav-section-line"></div>
          </div>
        ))}
      </div>
    </>
  );
};

export default MHNav;